module.exports = __webpack_public_path__ + "static/peace_domain-f0b68df6a7783b0b1f5fd3caad5b75b5.png";